import { ILinkedEntity } from '@kurtosys/types/api/search/ILinkedEntity.js';
import { IExecutionOptions, IQueryContextEntity, IQueryOptions } from '@kurtosys/types/query/index.js';
import { ITransformOptions } from '@kurtosys/types/query/transforms/ITransformOptions.js';

import { queryHelper } from '../queryUtils/index.js';

import { BaseTransform } from './BaseTransform.js';

export class MapTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any[] {
		const response: any[] = [];
		const { mapTransformOptions = {} } = this.options;
		const { transforms, entity } = mapTransformOptions;
		if (Array.isArray(queryResponse) && transforms && transforms.length > 0) {
			const context = queryHelper.getContext(executionOptions, queryOptions);

			const contextConfiguration = queryHelper.getContextConfiguration(executionOptions, queryOptions);
			const { queryId } = queryOptions;
			let entityConfiguration: IQueryContextEntity;
			let linkedEntities: ILinkedEntity[];
			if (contextConfiguration && contextConfiguration.entities) {
				entityConfiguration = contextConfiguration.entities.find((config) => config.id === queryId);
				linkedEntities = entityConfiguration && entityConfiguration.linkedEntities;
			}

			queryResponse.forEach((queryResponseItem) => {
				const subExecutionOptions: IExecutionOptions = { ...executionOptions, context };
				if (entity && entity.load && queryResponseItem) {
					if (linkedEntities) {
						// Get the entityMap and entitiesById based on the base entity
						const { entityMap, entitiesById } = context.entities[queryId];
						const queryContextEntityMap = entityMap.get(queryResponseItem.entityId);
						// Add this entity data to the entitiesById map
						entitiesById.set(queryResponseItem.entityId, queryResponseItem);
						// Add this entityId to the entityMap
						const entityId: Set<number> = new Set([queryResponseItem.entityId]);
						const overridingEntityMap = {
							...queryContextEntityMap,
							[entityConfiguration.id]: entityId,
						};
						subExecutionOptions.context = {
							entitiesById,
							entityMap: overridingEntityMap,
						};
					} else {
						const entityType = entity.entityType || queryResponseItem['type'];
						const baseContext = subExecutionOptions.context || {};
						const baseContextEntityByType = (baseContext && baseContext.entityByType) || {};
						subExecutionOptions.context = {
							...baseContext,
							entityByType: {
								...baseContextEntityByType,
								[entityType]: queryResponseItem,
							},
						};
					}
				}
				const finalValue = this.applyTransforms(
					queryResponseItem,
					transforms,
					queryOptions,
					subExecutionOptions,
				);
				response.push(finalValue);
			});
		}
		return response;
	}
	applyTransforms = (
		value: any,
		transforms: ITransformOptions[],
		queryOptions: IQueryOptions,
		executionOptions: IExecutionOptions,
	): any => {
		if (transforms) {
			for (const transformOptions of transforms) {
				const transform = new this.dependencies.transformClass(
					this.dependencies,
					transformOptions,
					this.translationHelper,
					this.callStackLevel,
				);
				value = transform.execute(value, queryOptions, { ...executionOptions, responseContext: value });
			}
		}
		return value;
	};
}
